import { isTelegramApp } from '@/utils/isTelegramApp';

const isDevMode = import.meta.env.VITE_IS_STAGING;

type GetShareLinkProps = {
  inviteCode: string | null;
  opId?: string | null;
  profId?: string | null;
  pollId?: string | null;
  tournamentId?: string | null;
  isReadable?: boolean;
};

export const getShareLink = ({
  inviteCode,
  opId = null,
  profId = null,
  pollId = null,
  tournamentId = null,
  isReadable,
}: GetShareLinkProps) => {
  if (!isTelegramApp()) {
    let path = '';
    if (opId) path = `/opinions/${opId}`;
    if (profId) path = `/profile/${profId}`;
    if (pollId) path = `/polls/${pollId}`;
    if (tournamentId) path = `/tournaments/${tournamentId}`;

    let inviteParam = '';
    if (inviteCode) inviteParam = `?inviteCode=${inviteCode}`;

    return `${window.location.origin}${path}${inviteParam}`;
  }

  const baseBot = isDevMode
    ? 'pollovote_test_bnaivcikec_bot/pollo_test'
    : 'pollovotebot/pollo';

  const params = [`startapp=${inviteCode}`];

  if (opId) params.push(`opId=${opId}`);
  if (profId) params.push(`profId=${profId}`);
  if (pollId) params.push(`pollId=${pollId}`);
  if (tournamentId) params.push(`tournamentId=${tournamentId}`);

  const botUrl = `https://t.me/${baseBot}?${params.join('--')}`;
  const encodedUrl = encodeURIComponent(botUrl);

  return isReadable ? botUrl : `https://t.me/share/url?url=${encodedUrl}`;
};
